<template>
  <span class="icon-terminal-manual">
    <icon-terminal />
    <span class="icon-terminal-manual_badge">
      <v-icon size="22" color="#fff">mdi-dialpad</v-icon>
    </span>
  </span>
</template>

<script>
  import IconTerminal from '@/components/icons/IconTerminal.vue'

  export default {
    name: 'IconTerminalManual',
    components: { IconTerminal },
  }
</script>

<style lang="less" scoped>
.icon-terminal-manual {
  position: relative;
  display: inline-block;
  width: 96px;
  height: 110px;

  > svg {
    display: block;
  }

  &_badge {
    position: absolute;
    left: 48px;
    top: 62px;
    width: 48px;
    height: 48px;
    box-sizing: border-box;
    border: 4px solid #fff;
    border-radius: 50%;
    background: #ff9100;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
